export default "__VITE_ASSET__Rzem7MZq__"